import { FormattedMessage } from 'react-intl';

import {
  FIELD_AMOUNT,
  FIELD_INTEREST_RATE,
  FIELD_MEMBERS,
  FIELD_MEMBER_SELECTED,
  LARGE_GRID_PROPS,
  SMALL_GRID_PROPS,
  COMMON_FIELD_NAMES,
} from './constants.fields';
import { validateNoSpecialChars } from 'utils/validateNoSpecialChars';

export const MSG_OTHERS = 'afforda.assets.details.others';

export const OTHER_FIELD_NAMES = {
  memberId: COMMON_FIELD_NAMES.memberId,
  amount: COMMON_FIELD_NAMES.amount,
  type: COMMON_FIELD_NAMES.type,
  interestRate: COMMON_FIELD_NAMES.interestRate,
  feesToConvertCash: COMMON_FIELD_NAMES.feesToConvertCash,
};

export const FIELDS = ({ intl, members, disabledMembers }) => {
  return [
    ...FIELD_MEMBERS({ members, disabledMembers }),
    // Type of Personal Property
    {
      ...FIELD_MEMBER_SELECTED,
      name: OTHER_FIELD_NAMES.type,
      label: <FormattedMessage id="afforda.assets.details.others.type" />,
      placeholder: intl.formatMessage({
        id: 'afforda.assets.details.others.type',
      }),
      rules: {
        required: true,
        validate: validateNoSpecialChars,
      },
      GridProps: LARGE_GRID_PROPS,
    },
    // Current Amount
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_AMOUNT,
      label: <FormattedMessage id="afforda.assets.details.currentAmount" />,
      placeholder: '0.00',
      name: OTHER_FIELD_NAMES.amount,
      rules: {
        required: true,
        max: 499999.99,
        min: 0,
        step: 0.01,
      },
      GridProps: SMALL_GRID_PROPS,
    },
    // Interest Rate
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_INTEREST_RATE,
      name: OTHER_FIELD_NAMES.interestRate,
      label: <FormattedMessage id="afforda.assets.details.interestRate" />,
      rules: {
        required: false,
        max: 100.0,
        min: 0.0,
        step: 0.01,
      },
      GridProps: SMALL_GRID_PROPS,
      placeholder: '0.00',
      helperText: <FormattedMessage id="afforda.assets.details.ifAplicable" />,
    },
    // Fees to Convert to Cash
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_AMOUNT,
      name: OTHER_FIELD_NAMES.feesToConvertCash,
      label: <FormattedMessage id="afforda.assets.details.feesConvertCash" />,
      placeholder: '0.00',
      rules: {
        required: false,
        max: 499999.99,
        min: 0,
        step: 0.01,
      },
      GridProps: SMALL_GRID_PROPS,
      helperText: <FormattedMessage id="afforda.assets.details.ifAplicable" />,
    },
  ];
};
